import { render, staticRenderFns } from "./GLMappingList.vue?vue&type=template&id=6508a313&"
import script from "./GLMappingList.vue?vue&type=script&lang=js&"
export * from "./GLMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports